__turbopack_context__.v({
  "className": "WbCy0a_className",
  "variable": "WbCy0a_variable",
});
